import styles from "./MyBillboard.module.css";

function MyBillboard({ b }) {
  const createdDate = new Date(b.createdAt);
  const expiresDate = new Date(b.expiresAt);
  const now = new Date();

  const created = createdDate.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  const expires = expiresDate.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return (
    <div
      className={`${styles.myBillboard} ${
        b.status === "PENDING APPROVAL"
          ? styles.myBillboardPending
          : b.status === "ACTIVE"
          ? styles.myBillboardActive
          : b.status === "REJECTED"
          ? styles.myBillboardRejected
          : b.status === "EXPIRED"
          ? styles.myBillboardExpired
          : ""
      }`}
    >
      <div className={styles.imageBox}>
        <img src={b.s3Url} alt="Uploaded" />
      </div>
      <div className={styles.right}>
        <div className={styles.header}>
          <div>{b.id}</div>
          {b.status === "ACTIVE" || b.status === "EXPIRED"
            ? created + " - " + expires
            : created}
        </div>
        <div className={styles.row}>
          <div className={styles.monthsAndTokens}>
            <p>
              {b.months} month{b.months > 1 ? `s` : ``}
            </p>
            <p>
              {b.status === "REJECTED" ? <s>🪙{b.spent}</s> : <>🪙{b.spent}</>}
              {b.status === "REJECTED" ? " (REFUNDED)" : ""}
            </p>
          </div>
          <div
            className={`${styles.status} ${
              b.status === "PENDING APPROVAL"
                ? styles.statusPending
                : b.status === "ACTIVE"
                ? styles.statusActive
                : b.status === "REJECTED"
                ? styles.statusRejected
                : b.status === "EXPIRED"
                ? styles.statusExpired
                : ""
            }`}
          >
            {b.status}
          </div>
        </div>

        {b.status === "REJECTED" && (
          <div className={styles.notes}>{b.notes}</div>
        )}

        {b.status === "ACTIVE" && (
          <div className={styles.timeRemaining}>
            {Math.ceil((expiresDate - now) / (1000 * 60 * 60 * 24))} days
            remaining
          </div>
        )}

        {b.status === "EXPIRED" && (
          <div className={styles.expiredInfo}>
            Created: {created} | Expired: {expires}
          </div>
        )}
      </div>
    </div>
  );
}

export default MyBillboard;
